import React, { Fragment, useState, useEffect } from "react";
import { defineMessages } from "react-intl";
import RadioFormGroup from "assets/scripts/components/common/form/RadioFormGroup/RadioFormGroup";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import isEmpty from "assets/scripts/utils/isEmpty";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
const messages = defineMessages({
    question: {
        id: "forms.profile.language.question",
        defaultMessage: "Please select your language preference"
    },
    english: {
        id: "forms.profile.language.english",
        defaultMessage: "English"
    },
    spanish: {
        id: "forms.profile.language.spanish",
        defaultMessage: "Spanish"
    },
    other: {
        id: "forms.profile.language.other",
        defaultMessage: "Other"
    },
    language: {
        id: "forms.profile.language.language",
        defaultMessage: "Language"
    }
});
const options = [
    {
        value: "English",
        label: messages.english
    },
    {
        value: "Spanish",
        label: messages.spanish
    },
    {
        value: "Other",
        label: messages.other
    },
];
export function getErrors(value) {
    return {
        languagePreference: isEmpty(value.languagePreference) ? REQUIRED : getMaxLengthError(value.languagePreference, 255)
    };
}
export default function ProfileLanguageInputs(props) {
    const [otherLang, setOtherLang] = useState("");
    const [option, setOption] = useState((props.value.languagePreference === null
        || props.value.languagePreference === undefined
        || props.value.languagePreference === "English")
        ? "English"
        : props.value.languagePreference === "Spanish"
            ? "Spanish"
            : "Other");
    useEffect(() => {
        if (option === "English" || option === "Spanish") {
            props.onChange({ languagePreference: option });
            return;
        }
        props.onChange({ languagePreference: otherLang });
    }, [option, otherLang]);
    return (<Fragment>
			<RadioFormGroup name="language" label={messages.question} value={option} onChange={setOption} options={options}/>

			{option === "Other" && (<TextFormGroup required name="otherlanguage" value={otherLang} onChange={setOtherLang} label={messages.language} error={props.errors.languagePreference}/>)}
		</Fragment>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileLanguageInputs/ProfileLanguageInputs.tsx